<template>
  <h2>NotFound</h2>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style>
</style>